import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { Modal } from '../Modal';
import { Button } from '../Button';
import { Typography } from '../Typography';
import { Title } from '../Typography/components';
import { COOKIE_CONSENT_CONTENT, COOKIE_CONSENT_TITLE, TCookieConsentBlock } from '../../constants/cookieConsent';
import * as styles from './styles.css';

interface ICookieConsentModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

const renderBlock = (block: TCookieConsentBlock, index: number): React.ReactNode => {
  switch (block.type) {
    case 'heading':
      return (
        <div className={styles['heading']} key={index}>
          <Title level={6}>{block.text}</Title>
        </div>
      );
    case 'paragraph':
      return (
        <div className={styles['paragraph']} key={index}>
          <Typography.Text level={4} tag="p" color="secondary">
            {block.text}
          </Typography.Text>
        </div>
      );
    case 'list':
      return (
        <ul className={styles['list']} key={index}>
          {block.items.map((item, itemIndex) => (
            <li className={styles['list-item']} key={itemIndex}>
              <Typography.Text level={4} color="secondary">
                {item}
              </Typography.Text>
            </li>
          ))}
        </ul>
      );
    default:
      return null;
  }
};

export const CookieConsentModal: React.FC<ICookieConsentModalProps> = ({ isOpen, onAccept, onCancel }) => {
  const deviceType = useDeviceType();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      type={deviceType === 'desktop' ? 'window' : 'curtain'}
      className={deviceType === 'desktop' ? styles['wide'] : styles['curtain']}
      header={
        <div className={styles['header']}>
          <Title level={4}>{COOKIE_CONSENT_TITLE}</Title>
        </div>
      }
    >
      <div className={styles['content']}>{COOKIE_CONSENT_CONTENT.map(renderBlock)}</div>

      <div className={styles['footer']}>
        <div className={styles['cancel-button']}>
          <Button theme="stroke_primary" size="L" onClick={onCancel}>
            Отменить
          </Button>
        </div>

        <div className={styles['accept-button']}>
          <Button size="L" onClick={onAccept}>
            Принять
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CookieConsentModal.displayName = 'CookieConsentModal';
